module.exports = __webpack_public_path__ + "static/media/consultor.b72ff16a.svg";